import * as actions from "../actions/index";

const initialState = {
  areaOfSpecialty: null,
};

const areaOfSpecialityReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_AREA_OF_SPECIALITY:
      return {
        ...state,
        areaOfSpecialty: action.payload,
      };

    default:
      return state;
  }
};
export default areaOfSpecialityReducer;
